import { useState, useEffect } from "react";
import { fetchJoinList, approveJoin, rejectJoin } from "../api/joinApi";
import Toast from "../components/Toast";

const statusLabel = { P: '대기', A: '승인', R: '반려' };
const statusColor = { P: '#fa8c16', A: '#52c41a', R: '#ff4d4f' };

export default function JoinApprovalPage({ onLogout }) {
  const [list,        setList]        = useState([]);
  const [loading,     setLoading]     = useState(false);
  const [toast,       setToast]       = useState('');
  const [statusFilter,setStatusFilter]= useState('P');
  const [selected,    setSelected]    = useState(null);
  const [rejectReason,setRejectReason]= useState('');
  const [showReject,  setShowReject]  = useState(false);

  const showToast = (msg) => { setToast(msg); setTimeout(() => setToast(''), 2500); };

  const loadList = async (status) => {
    setLoading(true);
    try {
      const res = await fetchJoinList(status);
      if (res.success) setList(res.data);
      else if (res.message === '토큰이 만료되었습니다. 다시 로그인해주세요.') onLogout();
    } catch (err) { showToast('❌ 목록 조회 실패'); }
    finally { setLoading(false); }
  };

  useEffect(() => { loadList(statusFilter); }, [statusFilter]);

  const handleApprove = async (item) => {
    if (!window.confirm(`${item.name}님의 가입을 승인하시겠습니까?`)) return;
    try {
      const res = await approveJoin(item.req_no);
      if (res.success) { showToast(`✅ ${res.message}`); setSelected(null); loadList(statusFilter); }
      else window.alert(res.message);
    } catch (err) { showToast('❌ 승인 처리 실패'); }
  };

  const handleReject = async () => {
    if (!rejectReason.trim()) { showToast('❌ 반려 사유를 입력해주세요.'); return; }
    try {
      const res = await rejectJoin(selected.req_no, rejectReason);
      if (res.success) {
        showToast('✅ 반려 처리되었습니다.');
        setShowReject(false); setSelected(null); setRejectReason('');
        loadList(statusFilter);
      } else showToast(`❌ ${res.message}`);
    } catch (err) { showToast('❌ 반려 처리 실패'); }
  };

  return (
    <div style={styles.wrap}>
      <Toast msg={toast} />

      <div style={styles.pageHeader}>
        <h1 style={styles.pageTitle}>📋 가입신청 관리</h1>
        <div style={{ display: "flex", gap: 6 }}>
          {[['', '전체'], ['P', '대기'], ['A', '승인'], ['R', '반려']].map(([val, label]) => (
            <button key={val}
              style={{ ...styles.filterBtn, ...(statusFilter === val ? styles.filterBtnActive : {}) }}
              onClick={() => setStatusFilter(val)}>{label}</button>
          ))}
        </div>
      </div>

      <div style={styles.card}>
        <div style={styles.tableHeader}>
            {["신청일", "성명", "사번", "전화번호", "소속", "부서", "직종", "상태"].map(h => (
            <div key={h} style={styles.th}>{h}</div>
            ))}
        </div>
        {loading ? (
          <div style={styles.empty}>⏳ 불러오는 중...</div>
        ) : list.length === 0 ? (
          <div style={styles.empty}>신청 내역이 없습니다.</div>
        ) : list.map((item, i) => (
          <div key={i} style={styles.tableRow}
            onClick={() => setSelected(item)}
            onMouseEnter={e => e.currentTarget.style.background = "#f8faff"}
            onMouseLeave={e => e.currentTarget.style.background = "#fff"}>
            <div style={styles.td}>{item.reg_dt?.slice(0, 10)}</div>
            <div style={{ ...styles.td, fontWeight: 600 }}>{item.name}</div>
            <div style={styles.td}>{item.emp_no        || '-'}</div>
            <div style={styles.td}>{item.phone}</div>
            <div style={styles.td}>{item.division_sub_name || '-'}</div>
            <div style={styles.td}>{item.department    || '-'}</div>
            <div style={styles.td}>{item.job_name      || '-'}</div>
            <div style={styles.td}>
            <span style={{ color: statusColor[item.status], fontWeight: 700, fontSize: 13 }}>
                {statusLabel[item.status]}
            </span>
            </div>
          </div>
        ))}
      </div>

      {/* 상세 모달 */}
      {selected && (
        <div style={ms.overlay}>
          <div style={ms.modal}>
            <div style={ms.header}>
              <span style={ms.title}>📋 가입신청 상세</span>
              <button style={ms.closeBtn} onClick={() => setSelected(null)}>✕</button>
            </div>
            <div style={ms.body}>
                {[
                { label: "성명",     value: selected.name },
                { label: "사번",     value: selected.emp_no            || '-' },
                { label: "전화번호", value: selected.phone },
                { label: "소속",     value: selected.division_sub_name || '-' },
                { label: "부서",     value: selected.department        || '-' },
                { label: "직종",     value: selected.job_name          || '-' },
                { label: "바라는점", value: selected.hope_msg          || '-' },
                { label: "신청일",   value: selected.reg_dt?.slice(0, 10) },
                { label: "상태",     value: statusLabel[selected.status] },
                ...(selected.status === 'R' ? [{ label: "반려사유", value: selected.reject_reason }] : []),
                ].map(f => (
                <div key={f.label} style={ms.fieldRow}>
                    <span style={ms.fieldLabel}>{f.label}</span>
                    <span style={ms.fieldValue}>{f.value}</span>
                </div>
                ))}
            </div>
            {selected.status === 'P' && (
              <div style={ms.footer}>
                <button style={ms.rejectBtn} onClick={() => setShowReject(true)}>✕ 반려</button>
                <button style={ms.approveBtn} onClick={() => handleApprove(selected)}>✅ 승인</button>
              </div>
            )}
            {selected.status !== 'P' && (
              <div style={ms.footer}>
                <button style={ms.cancelBtn} onClick={() => setSelected(null)}>닫기</button>
              </div>
            )}
          </div>
        </div>
      )}

      {/* 반려 사유 모달 */}
      {showReject && (
        <div style={{ ...ms.overlay, zIndex: 200 }}>
          <div style={{ ...ms.modal, maxWidth: 400 }}>
            <div style={ms.header}>
              <span style={ms.title}>✕ 반려 사유</span>
              <button style={ms.closeBtn} onClick={() => { setShowReject(false); setRejectReason(''); }}>✕</button>
            </div>
            <div style={ms.body}>
              <textarea
                style={{ width: "100%", border: "1.5px solid #e0e0e0", borderRadius: 8, padding: "10px 12px", fontSize: 14, outline: "none", resize: "vertical", minHeight: 100, boxSizing: "border-box" }}
                placeholder="반려 사유를 입력해주세요."
                value={rejectReason}
                onChange={e => setRejectReason(e.target.value)}
              />
            </div>
            <div style={ms.footer}>
              <button style={ms.cancelBtn} onClick={() => { setShowReject(false); setRejectReason(''); }}>취소</button>
              <button style={ms.rejectBtn} onClick={handleReject}>반려 처리</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

const styles = {
  wrap       : { background: "#f5f7fa", padding: 24, fontFamily: "'Noto Sans KR', sans-serif" },
  pageHeader : { display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 20 },
  pageTitle  : { fontSize: 22, fontWeight: 800, color: "#1a1a2e", margin: 0 },
  filterBtn  : { background: "#fff", border: "1.5px solid #e0e0e0", borderRadius: 8, padding: "6px 14px", fontSize: 13, color: "#666", cursor: "pointer", fontWeight: 500 },
  filterBtnActive: { background: "#e8f4fd", border: "1.5px solid #1677ff", color: "#1677ff", fontWeight: 700 },
  card       : { background: "#fff", borderRadius: 12, boxShadow: "0 2px 8px rgba(0,0,0,0.06)", overflow: "hidden" },
  tableHeader: { display: "grid", gridTemplateColumns: "1.5fr 1fr 1.5fr 1.5fr 1.5fr 1fr 0.8fr", padding: "12px 20px", background: "#f8faff", borderBottom: "1px solid #e8f0fe" },
  th         : { fontSize: 12, fontWeight: 700, color: "#888" },
  tableRow   : { display: "grid", gridTemplateColumns: "1.5fr 1fr 1.5fr 1.5fr 1.5fr 1fr 0.8fr", padding: "14px 20px", borderBottom: "1px solid #f5f5f5", cursor: "pointer", transition: "background 0.15s", alignItems: "center" },
  td         : { fontSize: 14, color: "#1a1a2e" },
  empty      : { textAlign: "center", padding: "60px 0", color: "#bbb", fontSize: 14 },
};

const ms = {
  overlay   : { position: "fixed", inset: 0, background: "rgba(0,0,0,0.45)", zIndex: 100, display: "flex", alignItems: "center", justifyContent: "center" },
  modal     : { background: "#fff", borderRadius: 16, width: "100%", maxWidth: 460, margin: "0 16px", boxShadow: "0 20px 60px rgba(0,0,0,0.3)", overflow: "hidden" },
  header    : { display: "flex", justifyContent: "space-between", alignItems: "center", padding: "20px 24px", borderBottom: "1px solid #f0f0f0" },
  title     : { fontSize: 16, fontWeight: 700, color: "#1a1a2e" },
  closeBtn  : { background: "none", border: "none", fontSize: 18, color: "#aaa", cursor: "pointer" },
  body      : { padding: "20px 24px", display: "flex", flexDirection: "column", gap: 12 },
  fieldRow  : { display: "flex", gap: 12, alignItems: "flex-start" },
  fieldLabel: { fontSize: 13, fontWeight: 600, color: "#888", minWidth: 70 },
  fieldValue: { fontSize: 14, color: "#1a1a2e", flex: 1 },
  footer    : { display: "flex", gap: 10, justifyContent: "flex-end", padding: "16px 24px", borderTop: "1px solid #f0f0f0" },
  cancelBtn : { background: "#fff", border: "1px solid #e0e0e0", borderRadius: 8, padding: "10px 20px", fontSize: 14, color: "#666", cursor: "pointer" },
  approveBtn: { background: "#52c41a", border: "none", borderRadius: 8, padding: "10px 20px", fontSize: 14, color: "#fff", fontWeight: 700, cursor: "pointer" },
  rejectBtn : { background: "#ff4d4f", border: "none", borderRadius: 8, padding: "10px 20px", fontSize: 14, color: "#fff", fontWeight: 700, cursor: "pointer" },
  tableHeader: { display: "grid", gridTemplateColumns: "1.2fr 1fr 1fr 1.3fr 1.3fr 1.3fr 1.3fr 0.8fr", padding: "12px 20px", background: "#f8faff", borderBottom: "1px solid #e8f0fe" },
  tableRow   : { display: "grid", gridTemplateColumns: "1.2fr 1fr 1fr 1.3fr 1.3fr 1.3fr 1.3fr 0.8fr", padding: "14px 20px", borderBottom: "1px solid #f5f5f5", cursor: "pointer", transition: "background 0.15s", alignItems: "center" },
};